import { GrfqLeg } from '#/unified-rfqs/entities/grfq/domain';
import formatDecimal from '@paradigm/utils/formatDecimal';

import * as Leg from '#/unified-rfqs/ui/rfqs/legs-functions';
import { getOppositeSide } from '#/unified-rfqs/ui/rfqs/quotes-functions';
import { getProduct, supportsUSDApproximation } from '#/products/domain';
import { LegTableView } from '#/unified-rfqs/ui/types';

export default function legsView(
  quantity: string,
  legs: readonly GrfqLeg[],
  side: 'BUY' | 'SELL',
) {
  return legs.map((leg, index) => processLeg(leg, index, quantity, side));
}

function processLeg(
  leg: GrfqLeg,
  index: number,
  quantity: string,
  sideQuote: 'BUY' | 'SELL',
): LegTableView {
  const { instrument, ratio, side, product_code, price } = leg;
  const product = processProductData(product_code);
  const currency = getProduct(leg.product_code).contractCurrency;
  const clearingUnitiesValue = Leg.toContractQuantityDisplay(leg, quantity);
  const clearingUnitiesQuantity = `${clearingUnitiesValue} ${currency}`;
  const contractTermsQuantity = supportsUSDApproximation(product_code)
    ? `${Leg.toContractSizeDisplay(leg, quantity)} Cts`
    : '';
  const { contractCurrency } = getProduct(leg.product_code);
  const { expiry, strike, instrumentLabel } = Leg.parseInstrument(instrument);
  return {
    side: sideQuote === 'BUY' ? side : getOppositeSide(side),
    ratio,
    index,
    expiry,
    instrument,
    clearingUnitiesQuantity,
    contractTermsQuantity,
    contractCurrency,
    instrumentLabel,
    rowNumber: index + 1,
    productLabel: product.label,
    productCurrency: product.currency,
    strike: strike != null ? formatDecimal(strike) : '-',
    price: price != null ? formatDecimal(price.toString()) : '-',
  };
}

function processProductData(product_code: string) {
  const product = getProduct(product_code);
  const [label = ''] = product.shortName.split('-');
  const { currency } = product;
  return {
    label,
    currency,
  };
}
